module.exports = __webpack_public_path__ + "static/img/medal@2x.24647c3b.png";